<template>
  <div class="page_evidence">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small">
          <!-- <el-form-item label="存证编号">
            <el-input v-model="listQuery.evidenceNo" placeholder="请输入存证编号" clearable style="width:180px"></el-input>
          </el-form-item> -->
          <el-form-item label="项目">
            <el-select v-model="listQuery.projectId" placeholder="请选择项目" clearable filterable style="width:180px">
              <el-option v-for="item in projectList" :key="item.Projectid" :label="item.StrprojectName" :value="item.Projectid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据类型">
            <el-select v-model="listQuery.dataType" placeholder="请选择数据类型" clearable filterable style="width:180px">
              <el-option v-for="(item, index) in dataTypeList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统计周期">
            <el-date-picker v-model="listQuery.cycle" style="width:180px" type="month" value-format="yyyy-MM"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="起止日期">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width:260px"
              @change="onDateRangeChange">
            </el-date-picker>
          </el-form-item> -->
        </el-form>
      </div>

      <div class="top-right">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>区块链</el-breadcrumb-item>
          <el-breadcrumb-item>存证管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="总览看板" name="0"></el-tab-pane>
          <el-tab-pane label="上链任务管理" name="1"></el-tab-pane>
          <el-tab-pane label="存证查询与验证" name="2"></el-tab-pane>
          <!-- <el-tab-pane label="证据出具" name="3"></el-tab-pane> -->
          <el-tab-pane label="系统管理" name="4"></el-tab-pane>
        </el-tabs>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column type="selection" width="48" align="center"></el-table-column>
          <el-table-column prop="projectName" label="项目名称" min-width="140" align="center"></el-table-column>
          <el-table-column prop="dataType" label="数据类型" min-width="100" align="center">
            <template slot-scope="{row}">
              {{ getDataTypeLabel(row.dataType) }}
            </template>
          </el-table-column>
          <el-table-column prop="cycle" label="统计周期" min-width="120" align="center"></el-table-column>
          <el-table-column prop="hash" label="哈希值" min-width="200" align="center" :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span class="hash_value" :title="row.hash">{{ formatHash(row.hash) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="chainTime" label="上链时间" min-width="170" align="center">
            <template slot-scope="{row}">{{ formatTime(row.createTime) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="160" align="center" fixed="right">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="verifyHandle(row)">验证</el-button>
                <el-button type="text" size="small" @click="detailHandle(row)">详情</el-button>
                <el-button type="text" size="small" @click="evidenceHandle(row)">证据出具</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block evidence_pagination">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageModel.page" :page-size="Number(listQuery.pageModel.rows)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 验证弹窗 -->
    <el-dialog title="存证验证" :visible.sync="verifyVisible" width="400px" class="res_dialog">
      <div class="verify_content" v-if="verifyForm.certUrl">
        <el-form :model="verifyForm" label-width="100px" size="small" class="verify_form">
          <el-form-item label="证书">
            <el-button type="primary" size="small" @click="toDownFile(verifyForm.certUrl)">下载</el-button>
          </el-form-item>
          <el-form-item label="原始文件">
            <el-button type="primary" size="small" @click="toDownFile(imgHead + verifyForm.rawData)">下载</el-button>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="verifyVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog title="存证详情" :visible.sync="detailVisible" width="680px" class="res_dialog">
      <el-form :model="detailForm" label-width="110px" size="small" class="detail_form">
        <el-form-item label="存证编号">
          <span>{{ detailForm.id }}</span>
        </el-form-item>
        <el-form-item label="数据类型">
          <span>{{ getDataTypeLabel(detailForm.dataType) }}</span>
        </el-form-item>
        <el-form-item label="项目名称">
          <span>{{ detailForm.projectName }}</span>
        </el-form-item>
        <el-form-item label="统计周期">
          <span>{{ detailForm.cycle }}</span>
        </el-form-item>
        <el-form-item label="哈希值">
          <span class="hash_full">{{ detailForm.hash }}</span>
        </el-form-item>
        <el-form-item label="上链时间">
          <span>{{ formatTime(detailForm.createTime) }}</span>
        </el-form-item>
        <el-form-item label="区块高度">
          <!-- <span>{{ detailForm.blockHeight }}</span> -->
        </el-form-item>
        <el-form-item label="存证数据">
          <pre class="evidence_data">{{ detailForm.recordCount }}</pre>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        loading: false,
        verifyLoading: false,
        tableData: [],
        totalCount: 0,
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: []
          },
          busiStat: '2',
          projectId: null,
          dataType: '',
          startDate: '',
          endDate: ''
        },
        activeName: '2',
        projectList: [],
        dataTypeList: [
          "录用通知",
          "排班记录",
          "接受排班",
          "任务派发记录",
          "接受任务",
          "考勤签到签退（含定位）",
          "考勤确认",
          "薪资确认",
          "验收单据",
          "结算资料",
          "付款凭证"
        ],
        verifyVisible: false,
        verifyForm: {},
        detailVisible: false,
        detailForm: {},
        imgHead: this.$store.state.EMP.imgPath,
        dateRange: []
      }
    },
    created() {
      this.getProList();
      this.getList();
    },
    methods: {
      changeTab() {
        if (this.activeName === '2') {
          this.getList();
        } else if (this.activeName == '0' || this.activeName == '1') {
          this.$router.push({
            path: '/onChainManage',
            query: { activeName: this.activeName }
          })
        }
      },
      //获取项目
      getProList() {
        let data = {
          roletype: localStorage.loginRoletype,
          projectname: "",
          perpage: 10000,
          currpage: 1,
        };
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          } else {
            this.projectList = [];
          }
        });
      },
      getList() {
        this.loading = true;
        xz.ArdCurStat(this.listQuery, 'GetBlockChainPageList').then(res => {
          if (res.status === 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.$message.error(res.msg || '获取数据失败');
          }
          this.loading = false;
        }).catch(error => {
          console.error('Error fetching evidence list:', error);
          this.tableData = [];
          this.totalCount = 0;
          this.loading = false;
        });
      },
      searchHandle() {
        this.listQuery.pageModel.page = 1;
        this.getList();
      },
      resetHandle() {
        this.listQuery.evidenceNo = '';
        this.listQuery.projectId = null;
        this.listQuery.dataType = '';
        this.listQuery.startDate = '';
        this.listQuery.endDate = '';
        this.dateRange = [];
        this.searchHandle();
      },
      currentChange(val) {
        this.listQuery.pageModel.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.pageModel.page = 1;
        this.listQuery.pageModel.rows = val;
        this.getList();
      },
      getDataTypeLabel(val) {
        return val || '-';
      },
      onDateRangeChange(val) {
        if (val && val.length === 2) {
          this.listQuery.startDate = val[0];
          this.listQuery.endDate = val[1];
        } else {
          this.listQuery.startDate = '';
          this.listQuery.endDate = '';
        }
      },
      toDownFile(url) {
        window.open(url);
      },
      formatHash(val) {
        if (!val) return '-';
        if (val.length > 14) {
          return val.substring(0, 10) + '...' + val.substring(val.length - 4);
        }
        return val;
      },
      formatTime(val) {
        if (!val) return '-';
        if (typeof val === 'string' && val.indexOf('T') > -1) {
          return val.replace('T', ' ');
        }
        return val;
      },
      verifyHandle(row) {
        let str = `?Ids=${row.id}`
        xz.ArdCurStatGetFun('EvidenceIssuance', str).then(res => {
          if (res.status === 'ok') {
            this.verifyForm = res.data;
            this.verifyVisible = true;
          } else {
            this.$message.error(res.msg || '验证失败');
          }
        });
        // this.verifyVisible = true;
      },
      confirmVerify() {
        this.verifyLoading = true;
        setTimeout(() => {
          this.verifyLoading = false;
          this.verifyForm.verified = true;
          this.$message.success('验证成功');
        }, 1200);
      },
      detailHandle(row) {
        this.detailForm = {
          ...row
        };
        this.detailVisible = true;
      },
      evidenceHandle(row) {
        let chainId;
        try {
          let a = JSON.parse(row.extendInfo);
          chainId = a.chainId;
        } catch (e) {
          this.$message.error('数据格式错误');
          return;
        }
        let d = {
          ids: row.id,
          chainId: chainId,
          proveDataId: ''
        }
        xz.ArdCurStat(d, 'ProveApply').then(res => {
          if (res.status === 'ok') {
            try {
              let url = res.data.okList[0].proves[0];
              let base64 = url.toString()
              let byteCharacters = atob(
                base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
              )
              let byteNumbers = new Array(byteCharacters.length)
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
              }
              let byteArray = new Uint8Array(byteNumbers)
              let blob = new Blob([byteArray], {
                type: `application/pdf`
              })
              let aLink = document.createElement("a")
              aLink.download = '证据出具.pdf' //这里写保存时的图片名称
              aLink.href = URL.createObjectURL(blob)
              aLink.click()
              // this.isBtnLoading = false;
            } catch (e) {
              console.log(e)
            }
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 16px;
    margin-bottom: 16px;
  }

  .evidence_pagination {
    margin-top: 12px;
    text-align: right;
  }

  .hash_value {
    font-family: Consolas, Monaco, monospace;
    color: #606266;
  }

  .hash_full {
    font-family: Consolas, Monaco, monospace;
    word-break: break-all;
    color: #606266;
  }

  .verify_form .el-form-item,
  .detail_form .el-form-item {
    margin-bottom: 12px;
  }

  .verify_pass {
    color: #67c23a;
    font-weight: bold;
  }

  .verify_fail {
    color: #f56c6c;
    font-weight: bold;
  }

  .evidence_data {
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 10px;
    font-size: 12px;
    max-height: 200px;
    overflow-y: auto;
    width: 460px;
    white-space: pre-wrap;
    word-break: break-all;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }
</style>

<style>
  .page_evidence .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_evidence .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_evidence .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_evidence .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>